// Paths
// Private
import { Faqs } from "../pages/FaqsPage"
// Public
import { Home } from "../pages/HomePage"
import { FCD } from "../pages/fcdPage"
import { Marketplace } from "../pages/MarketplacePage"
import { Mining } from "../pages/MiningPage"
import { NftBoxesCommanders } from "../pages/NftBoxesCommandersPage"
import { NftBoxesCommanders2 } from "../pages/NftBoxesCommandersPage2"
import { NftBoxesTurrets } from "../pages/NftBoxesTurretsPage"
import NftBoxesTurrets2 from "../pages/NftBoxesTurretsPage2"
import { PrivacyPolicy } from "../pages/PrivacyPolicyPage"
import { StakingNftPage } from "../pages/StakingNftPage"
import { Stacking } from "../pages/StakingPage"
import { TermsOfUse } from "../pages/TermsOfUsePage"
import { DashboardPage } from "../pages/account/DashboardPage"
import { TransactionsPage } from "../pages/account/TransactionsPage"
import { ReferalPage } from "../pages/account/ReferalPage"
import ReferralRedirectPage from "../pages/ReferralRedirectPage"
import { PATHS } from "./paths"
import { TournamentsPage } from "../pages/tournaments/TournamentsPage"
import { TournamentDetailsPage } from "../pages/tournaments/TournamentDetailsPage"
import { TournamentsHistoryPage } from "../pages/tournaments/TournamentsHistoryPage"

export const appRoutes = [
  {
    path: PATHS.HOME.PATH,
    label: PATHS.HOME.LABEL,
    type: PATHS.HOME.TYPE,
    Element: Home,
    isActive: true,
  },
  {
    path: PATHS.REF.PATH,
    label: PATHS.REF.LABEL,
    type: PATHS.REF.TYPE,
    Element: ReferralRedirectPage,
    isActive: true,
  },
  {
    path: PATHS.FCD.PATH,
    label: PATHS.FCD.LABEL,
    type: PATHS.FCD.TYPE,
    Element: FCD,
    isActive: true,
  },
  {
    path: PATHS.MARKET.PATH,
    label: PATHS.MARKET.LABEL,
    type: PATHS.MARKET.TYPE,
    Element: Marketplace,
    isActive: false,
  },
  {
    path: PATHS.STAKING.PATH,
    label: PATHS.STAKING.LABEL,
    type: PATHS.STAKING.TYPE,
    Element: Stacking,
    isActive: false,
  },
  {
    path: PATHS.STAKING_NFT.PATH,
    label: PATHS.STAKING_NFT.LABEL,
    type: PATHS.STAKING_NFT.TYPE,
    Element: StakingNftPage,
    isActive: false,
  },
  {
    path: PATHS.NFT_BOXES.NFT_BOXES_WITH_TURRETS.PATH,
    label: PATHS.NFT_BOXES.NFT_BOXES_WITH_TURRETS.LABEL,
    type: PATHS.NFT_BOXES.TYPE,
    Element: NftBoxesTurrets,
    isActive: false,
  },
  {
    path: PATHS.NFT_BOXES.NFT_BOXES_WITH_COMMANDERS.PATH,
    label: PATHS.NFT_BOXES.NFT_BOXES_WITH_COMMANDERS.LABEL,
    type: PATHS.NFT_BOXES.TYPE,

    Element: NftBoxesCommanders,
    isActive: false,
  },

  // ... NFT BOXES VER.2
  {
    path: PATHS.NFT_BOXES.NFT_BOXES_WITH_TURRETS_2.PATH,
    label: PATHS.NFT_BOXES.NFT_BOXES_WITH_TURRETS_2.LABEL,
    type: PATHS.NFT_BOXES.TYPE,
    Element: NftBoxesTurrets2,
    isActive: false,
  },
  {
    path: PATHS.NFT_BOXES.NFT_BOXES_WITH_COMMANDERS_2.PATH,
    label: PATHS.NFT_BOXES.NFT_BOXES_WITH_COMMANDERS_2.LABEL,
    type: PATHS.NFT_BOXES.TYPE,

    Element: NftBoxesCommanders2,
    isActive: false,
  },
  // ... end of NFT BOXES VER.2

  {
    path: PATHS.MINING.PATH,
    label: PATHS.MINING.LABEL,
    type: PATHS.MINING.TYPE,
    Element: Mining,
    isActive: false,
  },
  {
    path: PATHS.NFT_BOXES.NFT_BOXES_WITH_TURRETS.PATH,
    label: PATHS.NFT_BOXES.NFT_BOXES_WITH_TURRETS.LABEL,
    type: PATHS.NFT_BOXES.TYPE,
    Element: NftBoxesTurrets,
    isActive: false,
  },
  {
    path: PATHS.NFT_BOXES.NFT_BOXES_WITH_COMMANDERS.PATH,
    label: PATHS.NFT_BOXES.NFT_BOXES_WITH_COMMANDERS.LABEL,
    type: PATHS.NFT_BOXES.TYPE,

    Element: NftBoxesCommanders,
    isActive: false,
  },

  {
    path: PATHS.FAQS.PATH,
    label: PATHS.FAQS.LABEL,
    type: PATHS.FAQS.TYPE,
    Element: Faqs,
    isActive: false,
  },
  {
    path: PATHS.ACCOUNT.PATH,
    label: PATHS.ACCOUNT.LABEL,
    type: PATHS.ACCOUNT.TYPE,
    Element: DashboardPage,
    isActive: true,
  },
  {
    path: PATHS.TRANSACTIONS.PATH,
    label: PATHS.TRANSACTIONS.LABEL,
    type: PATHS.TRANSACTIONS.TYPE,
    Element: TransactionsPage,
    isActive: true,
  },
  {
    path: PATHS.REFERAL.PATH,
    label: PATHS.REFERAL.LABEL,
    type: PATHS.REFERAL.TYPE,
    Element: ReferalPage,
    isActive: true,
  },
  {
    path: PATHS.TERMS_OF_USE.PATH,
    label: PATHS.TERMS_OF_USE.LABEL,
    type: PATHS.TERMS_OF_USE.TYPE,

    Element: TermsOfUse,
    isActive: false,
  },
  {
    path: PATHS.PRIVACY_POLICY.PATH,
    label: PATHS.PRIVACY_POLICY.LABEL,
    type: PATHS.PRIVACY_POLICY.TYPE,
    Element: PrivacyPolicy,
    isActive: false,
  },
  {
    path: PATHS.TOURNAMENTS.PATH,
    label: PATHS.TOURNAMENTS.LABEL,
    type: PATHS.TOURNAMENTS.TYPE,
    Element: TournamentsPage,
    isActive: false,
  },
  {
    path: PATHS.TOURNAMENTS.PATH,
    label: PATHS.TOURNAMENTS.LABEL,
    type: PATHS.TOURNAMENTS.TYPE,
    Element: TournamentsPage,
    isActive: false,
  },
  {
    path: PATHS.TOURNAMENT_DETAILS.ROUTE,
    label: PATHS.TOURNAMENT_DETAILS.LABEL,
    type: PATHS.TOURNAMENT_DETAILS.TYPE,
    Element: TournamentDetailsPage,
    isActive: false,
  },
  {
    path: PATHS.TOURNAMENTS_HISTORY.PATH,
    label: PATHS.TOURNAMENTS_HISTORY.LABEL,
    type: PATHS.TOURNAMENTS_HISTORY.TYPE,
    Element: TournamentsHistoryPage,
    isActive: false,
  },
]
